const cardItems = [
  {
    title: '顶流小生绯闻女友身份被扒，原来是她',
    desc: '网友通过对比行程和同款穿搭，锁定某新晋小花旦，两人曾多次同框被拍。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20two%20silhouetted%20figures%20walking%20apart%20on%20a%20rainy%20city%20street%20at%20night%2C%20neon%20pink%20light%20reflections%20on%20wet%20pavement%2C%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20dramatic%20shadows%2C%20no%20visible%20faces&width=800&height=450&seq=card-gossip-01&orientation=landscape',
  },
  {
    title: '网红直播间被封真相，平台出手整顿',
    desc: '因涉嫌虚假宣传和诱导未成年人打赏，多名头部主播直播间被永久封禁。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20glitch%20effect%20on%20a%20digital%20screen%20showing%20a%20live%20stream%20interface%20with%20distorted%20pixels%20in%20hot%20pink%20and%20red%20tones%2C%20error%20aesthetic%2C%20dark%20background%2C%20cyberpunk%20vibe%2C%20distressed%20digital%20art%2C%20screen%20static%20effect&width=800&height=450&seq=card-gossip-02&orientation=landscape',
  },
  {
    title: '某综艺幕后剧本曝光，嘉宾人设全是演的',
    desc: '内部工作人员截图流出，详细标注每位嘉宾的剧本走向和情绪爆发时间点。',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20scattered%20script%20pages%20on%20a%20dark%20table%20with%20red%20markup%20annotations%20and%20highlighted%20lines%2C%20dramatic%20overhead%20lighting%20casting%20deep%20shadows%2C%20mysterious%20Hollywood%20behind%20the%20scenes%20aesthetic%2C%20warm%20tungsten%20light%2C%20cinematic%20mood&width=800&height=450&seq=card-gossip-03&orientation=landscape',
  },
  {
    title: '知名歌手演唱会假唱实锤，观众要求退票',
    desc: '音乐博主逐帧对比现场音频与录音室版本，波形图几乎完全一致引发众怒。',
    image: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20singer%20on%20a%20massive%20concert%20stage%20with%20empty%20audience%20seats%2C%20dramatic%20spotlight%20beam%20in%20hot%20pink%2C%20lonely%20atmosphere%2C%20dark%20arena%2C%20theatrical%20lighting%2C%20glossy%20floor%20reflections&width=800&height=450&seq=card-gossip-04&orientation=landscape',
  },
  {
    title: '影视公司CEO涉嫌洗钱，名下资产被冻结',
    desc: '经侦部门已介入调查，该公司近三年出品多部票房过十亿的热门大片均被列入审查。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20building%20facade%20at%20night%20with%20boarded%20up%20windows%2C%20harsh%20security%20floodlight%20creating%20long%20shadows%2C%20cold%20urban%20atmosphere%2C%20crime%20scene%20vibe%2C%20dark%20and%20foreboding%2C%20minimal%20composition&width=800&height=450&seq=card-gossip-05&orientation=landscape',
  },
  {
    title: '选秀节目投票造假，制作方被罚千万',
    desc: '监管部门通报多档选秀节目存在粉丝集资打投乱象，将出台新政规范行业。',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20voting%20ballots%20and%20scorecards%20scattered%20on%20a%20dark%20surface%2C%20dramatic%20side%20lighting%2C%20some%20cards%20marked%20in%20red%2C%20tense%20dramatic%20atmosphere%2C%20documentary%20photojournalism%20style%2C%20high%20contrast%20black%20and%20red&width=800&height=450&seq=card-gossip-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10">
          📸 今日爆料
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.map((card, idx) => (
            <article
              key={idx}
              className={`bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:translate-y-[-4px] transition-transform duration-300 ${
                idx === 3 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full">
                    <i className="ri-flashlight-line w-3 h-3 flex items-center justify-center"></i>
                    猛料
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 leading-snug line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}